import React, { createContext, useContext, useState } from 'react';

interface HistoryRefreshContextType {
  historyNeedsRefresh: boolean;
  setHistoryNeedsRefresh: (pending: boolean) => void;
}

const HistoryRefreshContext = createContext<HistoryRefreshContextType | undefined>(undefined);

export const HistoryRefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [historyNeedsRefresh, setHistoryNeedsRefresh] = useState(false);
  return (
    <HistoryRefreshContext.Provider value={{ historyNeedsRefresh, setHistoryNeedsRefresh }}>
      {children}
    </HistoryRefreshContext.Provider>
  );
};

export function useHistoryRefresh() {
  const context = useContext(HistoryRefreshContext);
  if (!context) {
    throw new Error('useHistoryRefresh debe usarse dentro de HistoryRefreshProvider');
  }
  return context;
} 